export const routeConfig = {
  profile: 'profile',
  password: 'password',
  linkAccount: 'linkAccount',
  activeSessions: 'activeSessions',
} as const;
